import moment from 'moment';

export const formatDateTime = (date) => {
  // Convert to IST (UTC+5:30) regardless of client timezone
  return moment(date).utcOffset('+05:30').format('DD-MM-YYYY h:mm a');
};
